export default "__VITE_ASSET__55769e09__"